import React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import { Trans } from 'react-i18next';
import PropTypes from 'prop-types';

import { routeNode, routerStore } from 'core/routing';
import { useAppManager } from 'apps/hooks';

import { media } from 'legacyComponents/styled/styleUtils';
import { MainWrapper, Div } from 'legacyComponents/styled/lib';
import { RepoSpinner } from 'apps/repository/styles';
import {
  SideNavBarWrapper,
  SideNavBar,
  SideNavBarItem,
  SideNavBarLink,
} from 'legacyComponents/sideNavBar';

import { FourOhFour } from '../../fourOhFour';
// import { Home } from './tabs/home';
import { TeamSettings } from './tabs/team';
import { BillingSettings } from './tabs/billing';
import { RouterAppManager } from './appManager';

const viewsMap = {
  // '': Home,
  teams: TeamSettings,
  billing: BillingSettings,
};

const InitiativeSettings = observer(props => {
  const manager = useAppManager(RouterAppManager, null, {}, true, [
    props.route.params.spacePath,
  ]);
  const View = props.componentFromRoute();
  const { loading, notFound, isAllowed } = manager;

  if (loading) {
    return (
      <MainWrapper marginBottom='90px'>
        <RepoSpinner />
      </MainWrapper>
    );
  }

  if (notFound || !isAllowed) {
    return <FourOhFour />;
  }
  const { route } = props;
  const initiativeParam = { spacePath: route.params.spacePath };

  return (
    <>
      <TopBarNoFlex className='noScrollBar'>
        <h1>
          {initiativeParam.spacePath}&apos;s <Trans>settings</Trans>
        </h1>
      </TopBarNoFlex>
      <MainWrapper>
        <Div display='inline-block' width='100%'>
          <SideNavBarWrapper>
            <SideNavBar>
              <SideNavBarItem isTitle>
                <Trans>Organisation Settings</Trans>
              </SideNavBarItem>
              <SideNavBarItem>
                <SideNavBarLink
                  name='workspace.spaceSettings.teams'
                  params={initiativeParam}
                  active={route.name.includes('teams')}
                >
                  <Trans>Member privileges</Trans>
                </SideNavBarLink>
              </SideNavBarItem>
              <SideNavBarItem last>
                <SideNavBarLink
                  name='workspace.spaceSettings.billing'
                  params={initiativeParam}
                  active={route.name.includes('billing')}
                >
                  <Trans>Billing</Trans>
                </SideNavBarLink>
              </SideNavBarItem>
            </SideNavBar>
          </SideNavBarWrapper>
          <SettingsWrapper>
            <View params={props.routerStore.params} />
          </SettingsWrapper>
        </Div>
      </MainWrapper>
    </>
  );
});

export const SettingsWrapper = styled.div`
  width: calc(75% - 10px);
  float: right;
  margin-top: 30px;
  margin-bottom: 60px;
  height: auto;
  ${media.l`
    width: calc(73% - 10px);
  `};
  ${media.m`
    width: 100%;
  `};
`;

const TopBarNoFlex = styled.div`
  width: ${props => props.theme.layout.maxWidth};
  margin: 0 auto;
  z-index: 2;
  padding: ${props => props.theme.spacing.medium} 4vw;
  white-space: nowrap;
  overflow-x: auto;
`;

class RedirectToTeam extends React.Component {
  constructor(props) {
    super(props);
    const {
      route: { params },
    } = routerStore;
    routerStore.navigate(`workspace.spaceSettings.teams`, params, {
      replace: true,
    });
  }

  render() {
    return null;
  }
}

RedirectToTeam.propTypes = {
  clientStore: PropTypes.object,
};

InitiativeSettings.propTypes = {
  route: PropTypes.object,
  routerStore: PropTypes.object,
  componentFromRoute: PropTypes.func,
};

export const InitiativeSettingsRouter = routeNode(
  'workspace.spaceSettings',
  viewsMap,
  RedirectToTeam,
)(InitiativeSettings);
